import { GlobalStyles } from "@mui/material";
import Layout from "./src/components/layout";

export default ({ element, props }) => {
  return (
    <Layout {...props}>
      <GlobalStyles
        styles={(theme) => ({
          // '.html p': {
          //   margin: '0',
          //   marginBottom: '10px'
          // },
          // 'html': {
          //   // overflowX: 'hidden',
          //   backgroundColor: theme.palette.primary.light,
          // },
          // 'body': {
          //   // overflowX: 'hidden',
          //   // color: theme.palette.text.primary,
          //   backgroundColor: theme.palette.primary.light,
          // },
          'ul': {
            paddingInlineStart: '1.5rem'
          },
          'blockquote': {
            color: 'inherit',
            fontStyle: 'italic',
            marginInlineStart: '1rem',
            marginInlineEnd: '1rem'
          }
        })}
      />
      {element}
    </Layout>
  )
}
